export default {
  TODAY: 0,
  TOMORROW: 1,
  NEXT_WEEK: 7,
  NEXT_TWO_WEEKS: 14,
  NEXT_THREE_WEEKS: 21,
  NEXT_MONTH: 30,
  NEXT_YEAR: 365,
  NEXT_THREE_YEARS: 1095,
  NEXT_FIVE_YEARS: 1825,
};
